import { ThumbsDown, ThumbsUp } from "lucide-react";
import { useRaelaRating, type Thumb } from "@/lib/contribute/useRating";

interface Props {
  messageId: string;
  traceId?: string | null;
}

const MessageRating = ({ messageId, traceId = null }: Props) => {
  const { get, rate } = useRaelaRating();
  const value = get(messageId);

  const set = (v: Thumb) => {
    void rate(messageId, traceId, value === v ? 0 : v);
  };

  return (
    <div className="mt-2 flex items-center gap-2 text-[11px] text-muted-foreground">
      <button
        type="button"
        aria-label="Helpful"
        onClick={() => set(1)}
        className={`grid h-6 w-6 place-items-center rounded-full transition ${
          value === 1 ? "bg-success/20 text-success" : "hover:bg-muted"
        }`}
      >
        <ThumbsUp className="h-3 w-3" />
      </button>
      <button
        type="button"
        aria-label="Not helpful"
        onClick={() => set(-1)}
        className={`grid h-6 w-6 place-items-center rounded-full transition ${
          value === -1 ? "bg-destructive/20 text-destructive" : "hover:bg-muted"
        }`}
      >
        <ThumbsDown className="h-3 w-3" />
      </button>
      {value !== 0 && (
        <span className="text-[10px]">
          You rated this {value === 1 ? "helpful" : "not helpful"}.
        </span>
      )}
    </div>
  );
};

export default MessageRating;
